import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/Websites/2solutions/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Websites/2solutions/node_modules/next/dist/client/image-component.js");
